import {LayerAttributeVO, EnumTypLayerAttr} from '../api';
import {Yup} from '@mc/ui-v4';

const getFieldSchema = (attribute: LayerAttributeVO) => {
    switch (attribute.typ) {
        case EnumTypLayerAttr.INT:
            if (attribute.povinnost) {
                return Yup.number().integer().required(`Prosím vyplňte ${attribute.popis}`);
            } else {
                return Yup.number().integer().nullable();
            }
        case EnumTypLayerAttr.NUMBER:
            if (attribute.povinnost) {
                return Yup.number().required(`Prosím vyplňte ${attribute.popis}`);
            } else {
                return Yup.number().nullable();
            }
        case EnumTypLayerAttr.TEXT:
            if (attribute.povinnost) {
                return Yup.string().required(`Prosím vyplňte ${attribute.popis}`);
            } else {
                return Yup.string().nullable();
            }
        case EnumTypLayerAttr.STRING: {
            // MCW-29132 – hodnota se dle interpretace (odkaz / e-mail / telefon) nevaliduje, interpretace
            // ovlivňuje jen formátování hodnoty v detailu objektu.
            // Pokud atribut nemá nastavenou maximální délku (starší konfigurace bez výchozí hodnoty),
            // Yup .max(undefined, ...) by neprošlo pro žádnou neprázdnou hodnotu – kontrolu délky proto vynecháme.
            let stringSchema = Yup.string();
            if (attribute.delka != null) {
                stringSchema = stringSchema.max(attribute.delka, `Prosím vyplňte v maximální délce ${attribute.delka}`);
            }
            return attribute.povinnost ? stringSchema.required(`Prosím vyplňte ${attribute.popis}`) : stringSchema.nullable();
        }
        case EnumTypLayerAttr.BOOLEAN:
            return Yup.bool();
        case EnumTypLayerAttr.ENUM:
            if (attribute.povinnost) {
                return Yup.mixed().required(`Prosím vyberte ${attribute.popis}`);
            } else {
                return Yup.mixed().nullable();
            }
        case EnumTypLayerAttr.DATE_TIME:
            if (attribute.povinnost) {
                return Yup.date().required(`Prosím vyplňte ${attribute.popis}`);
            } else {
                return Yup.date().nullable();
            }
        case EnumTypLayerAttr.ACCESSIBILITY:
            if (attribute.povinnost) {
                return Yup.string().required(`Prosím vyplňte ${attribute.popis}`);
            } else {
                return Yup.string().nullable();
            }
        default:
            throw new Error(`Neznámý datový typ: ${attribute.typ}`);
    }
};

/**
 * Atributy s tečkou v názvu (např. "ev. cislo") se pro `<Field name>` obalují do `["…"]"`, aby je
 * react-final-form bral jako doslovný klíč a nerozdělil podle teček na vnořenou cestu (viz AttributesModal /
 * BulkEditModal). react-final-form si tak hodnotu ukládá pod PŮVODNÍ (nezabalený) klíč, ale Yup žádnou
 * cestovou notaci nezná a klíč schématu by bral doslovně i s hranatými závorkami – proto schéma musíme
 * vždy stavět na nezabaleném názvu, jinak by required/max u takového atributu selhávalo vždy.
 */
export const unwrapFieldName = (nazev: string): string => {
    const match = /^\["(.*)"\]$/.exec(nazev);
    return match ? match[1] : nazev;
};

export const formSchema = (attributes: LayerAttributeVO[]) => {
    const schema = {};
    attributes.forEach((attribute: LayerAttributeVO): void => {
        schema[unwrapFieldName(attribute.nazev)] = getFieldSchema(attribute);
    });
    return Yup.object().shape(schema);
};
